import type { ExtraordinaryInstallmentFeeQuery } from 'aem-libs-api/src/services/building-savings-product/v1/types'
import { createInletStore } from 'aem-libs-react-components/src/store/createInletStore'
import { formatDateISO } from 'aem-libs-ts/src/utils/formatting/dates/formatDateISO'

import type { EarlyRepaymentParams } from './types'

export type ExtraordinaryInstallmentInputType = ExtraordinaryInstallmentFeeQuery & {
  isWillingToRepayWholeAmount: boolean
}

export const earlyRepaymentStore = createInletStore(
  null as unknown as ExtraordinaryInstallmentInputType,
  null,
  (set) => ({
    setAccnr: (accnr: string) => set((request) => ({ ...request, accnr })),
    setAmount: (amount: number) => set((request) => ({ ...request, amount })),
    setDate: (date: Date) => set((request) => ({ ...request, date: formatDateISO(date) })),
    setWillingToRepayWholeAmount: (isWillingToRepayWholeAmount: boolean) =>
      set((request) => ({ ...request, isWillingToRepayWholeAmount }))
  })
)

export const initStore = (params: EarlyRepaymentParams) =>
  earlyRepaymentStore
    .initialize()
    .map(() => ({
      accnr: '',
      amount: params.repaymentInputConfig.default,
      date: params.repaymentDateDefault || formatDateISO(new Date()),
      isWillingToRepayWholeAmount: params.isWillingToRepayWholeAmount || false
    }))
    .use()
